import { render } from "./Witness.vue?vue&type=template&id=69299b0d&scoped=true"
import script from "./Witness.vue?vue&type=script&lang=js"
export * from "./Witness.vue?vue&type=script&lang=js"

import "./Witness.vue?vue&type=style&index=0&id=69299b0d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69299b0d"]])

export default __exports__